"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.AUTO_COMPLETE_VALUE = exports.AUTO_COMPLETE_SUFFIX = exports.AUTO_COMPLETE_PREFIX = exports.AUTO_COMPLETE_OPTION = exports.AUTO_COMPLETE = exports.LIST_OPTION = exports.LIST_CONTAINER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../vars"),
    _input = require("./input");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var LIST_BOX = (0, _cxs["default"])({
  paddingInlineStart: 0,
  listStyleType: "none",
  margin: 0
}),
    LIST_CONTAINER = (0, _cxs["default"])({
  boxShadow: "0 2px 4px 0 ".concat(_vars.COLOURS.grey.mischka.russian),
  position: "absolute",
  width: "100%",
  zIndex: 2,
  maxHeight: "252px",
  overflowY: "auto"
});
exports.LIST_CONTAINER = LIST_CONTAINER;

var PADDING = function PADDING(a) {
  var b = a.hasPrefix;
  return {
    padding: "15px 15px 15px ".concat(b ? _input.PREFIX.paddingLeft : "15px")
  };
},
    LIST_OPTION = function LIST_OPTION() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.hasPrefix;
  return (0, _cxs["default"])(_objectSpread({}, PADDING({
    hasPrefix: b
  }), {
    background: _vars.COLOURS.mono.white,
    borderBottom: "1px solid ".concat(_vars.COLOURS.grey.mischka.russian),
    cursor: "pointer",
    ":last-of-type": {
      borderBottom: 0
    },
    ":hover": {
      background: _vars.COLOURS.grey.catSkillWhite
    }
  }));
};

exports.LIST_OPTION = LIST_OPTION;

var CONTAINER = (0, _cxs["default"])({
  width: "100%"
}),
    AUTO_COMPLETE = function AUTO_COMPLETE(a) {
  var b = a.hasPrefix;
  return {
    container: CONTAINER,
    suggestionsContainer: LIST_CONTAINER,
    suggestionsList: LIST_BOX,
    suggestion: LIST_OPTION({
      hasPrefix: b
    })
  };
};

exports.AUTO_COMPLETE = AUTO_COMPLETE;
var AUTO_COMPLETE_OPTION = (0, _cxs["default"])({
  display: "flex",
  alignItems: "center",
  width: "100%"
});
exports.AUTO_COMPLETE_OPTION = AUTO_COMPLETE_OPTION;
var AUTO_COMPLETE_PREFIX = (0, _cxs["default"])({
  display: "flex",
  width: "35px",
  marginLeft: "5px"
});
exports.AUTO_COMPLETE_PREFIX = AUTO_COMPLETE_PREFIX;
var AUTO_COMPLETE_SUFFIX = (0, _cxs["default"])({
  display: "flex",
  marginRight: "5px"
});
exports.AUTO_COMPLETE_SUFFIX = AUTO_COMPLETE_SUFFIX;
var AUTO_COMPLETE_VALUE = (0, _cxs["default"])({
  flex: 1
});
exports.AUTO_COMPLETE_VALUE = AUTO_COMPLETE_VALUE;